<script setup>

import { ref, computed, watch, nextTick } from 'vue';
import Dialog from 'primevue/dialog';

const { utilisateur } = defineProps({
    utilisateur: Object
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['enregistrer']);

const utilisateurModifie = ref({...utilisateur});

watch(() => visible.value, (visible) => {
    if (visible) {
        nextTick(() => {
            utilisateurModifie.value = {...utilisateur};
        });
    }
});

function estSaisieValide() {
    return utilisateurModifie.value.nomFamille && utilisateurModifie.value.prenom && utilisateurModifie.value.email;
}

function enregistrer() {
    utilisateurModifie.value.inconnu = false;
    emit('enregistrer', utilisateurModifie.value);
}

</script>

<template>
    <Dialog 
        v-model:visible="visible" 
        modal 
        :closable="!utilisateur?.inconnu"
        :header="utilisateur?.inconnu ? `Nouvel utilisateur : ${utilisateur.nomIdentifiant}` : `Informations de l'utilisateur : ${utilisateur.nomIdentifiant}`">
            <div class="infos-utilisateur" @keydown.enter.prevent="enregistrer()">
                <label class="intitule">Nom :</label>
                <input type="text" autofocus spellcheck="false" v-model="utilisateurModifie.nomFamille" />
                <label class="intitule">Prénom :</label>
                <input type="text" spellcheck="false" v-model="utilisateurModifie.prenom" />
                <label class="intitule">Email :</label>
                <input type="text" spellcheck="false" v-model="utilisateurModifie.email" />
            </div>
            <template #footer>
                <button 
                    class="bouton fas fa-check" 
                    :disabled="!estSaisieValide()"
                    @click="enregistrer()"/>
            </template>
    </Dialog>
</template>

<style scoped>

.infos-utilisateur {
	display: grid;
	grid-template-columns: auto auto;
	gap: 2px;
	align-items: start;
    margin-top: 2px;
}

</style>